import { Action } from '@ngrx/store';
import { type } from '@app/store/util';

export const LOAD = type('[Correspondences] Load Correspondences');
export const LOAD_SUCCESS = type('[Correspondences] Load Correspondences Success');

export const LOAD_ERROR = type('[Correspondences] Load Error');

export class Load implements Action {
    public type: string = LOAD;
    constructor(public payload: { relatie_id: number, dossier_volgnummer: number }) {}
}

export class LoadSuccess implements Action {
    public type: string = LOAD_SUCCESS;
    constructor(public payload: { correspondences: any, dossier_volgnummer: number}) {}
}

export class LoadError implements Action {
    public type: string = LOAD_ERROR;
    constructor(public payload?: any) {}
}

export type Actions
    = Load
    | LoadSuccess
    | LoadError;
